import {
    AmplitudeItemListName,
    getAmplitudeViewItemEventProperties,
    IAmplitudeViewItemOffer,
    IAmplitudeViewItemProperty
} from "./get_amplitude_view_item_event_properties";

export interface IGetAmplitudePropertySelectItemEventPropertiesParams {
    offer: IAmplitudeViewItemOffer;
    property: IAmplitudeViewItemProperty;
    index: number;
    itemListId?: string;
    itemListName?: AmplitudeItemListName;
}

export const getAmplitudePropertySelectItemEventProperties = ({
    offer,
    property,
    index,
    itemListId,
    itemListName
}: IGetAmplitudePropertySelectItemEventPropertiesParams): Record<string, string | string[] | number> => ({
    ...getAmplitudeViewItemEventProperties({
        offer,
        property,
        itemListId,
        itemListName
    }),
    ...(property.price != null ? {item_price: property.price} : {}),
    index
});
import {
    AmplitudeItemListName,
    getAmplitudeViewItemEventProperties,
    IAmplitudeViewItemOffer,
    IAmplitudeViewItemProperty
} from "./get_amplitude_view_item_event_properties";

export interface IGetAmplitudePropertySelectItemEventPropertiesParams {
    offer: IAmplitudeViewItemOffer;
    property: IAmplitudeViewItemProperty;
    index: number;
    itemListId?: string;
    itemListName?: AmplitudeItemListName;
}

export const getAmplitudePropertySelectItemEventProperties = ({
    offer,
    property,
    index,
    itemListId,
    itemListName
}: IGetAmplitudePropertySelectItemEventPropertiesParams): Record<string, string | string[] | number> => ({
    ...getAmplitudeViewItemEventProperties({
        offer,
        property,
        itemListId,
        itemListName
    }),
    ...(property.price != null ? {item_price: property.price} : {}),
    index
});
